import * as ProductSlider from './product-slider';

var $products;

export function init (settings) {
  $products = $(settings.el);

  ProductSlider.init({
    el: settings.slider
  });

  _bindEvents();
}

function _bindEvents () {
  $products.on('click', '.js-option-values .btn', _selectOption);

  $('.has-slider').on('product:select-option', (e, $option) => {
    ProductSlider.toggle($option.children('input').val());
  });
}

function _selectOption () {
  let $option = $(this);
  let $product = $option.closest($products);
  let variant = $option.data('variant');

  if ($option.is('.disabled')) {
    return false;
  }

  $product
    .find('.product-offer')
    .each((index, offer) => {
      let $offer = $(offer);

      // Show or hide the offer if the offer has the variant we need
      $offer.toggleClass('d-none', $offer.data('variant') != variant);
    });

  $product.trigger('product:select-option', [$option]);
}
